import { Endpoint } from '../utils/endpoint.util';

const sbiParentUrl = '/sbi';
const srmParentUrl = '/srm';
const registrationParentUrl = '/matricula';
const citizenParentUrl = '/cidadao';
const attendanceParentUrl = '/atendimento';
const contactUsParentUrl = '/faleConosco';
const satisfactionSurveyParentUrl = '/pesquisaSatisfacao';
const solicitationParentUrl = '/solicitacao';
const faqParentUrl = '/perguntaFrequente';
const addressParentUrl = '/endereco';
const guiaMedicoParentUrl = '/guia-medico';
const consultaCoberturaParentUrl = '/consulta-cobertura';

const pesquisaPrestadores = '/formulario_pesquisa';

const simulador = '/simulador';

export const ENDPOINTS = {
  userData: new Endpoint(`${sbiParentUrl}/dados-cadastro`),
  registrationData: new Endpoint(`${sbiParentUrl}/dados-cadastro/chave-cadastrado`),
  registrationsList: new Endpoint(`${sbiParentUrl}${registrationParentUrl}/lista`),
  activeRegistrationsList: new Endpoint(`${sbiParentUrl}${registrationParentUrl}/lista/ativas`),
  planData: new Endpoint(`${sbiParentUrl}/plano`),
  healthDeclarationQuestions: new Endpoint(`${sbiParentUrl}/declaracao-saude/questionario`),
  sendHealthDeclarationAnswers: new Endpoint(`${sbiParentUrl}/declaracao-saude`),
  requestCardEmission: new Endpoint(`${sbiParentUrl}/solicitacao-cartao`),
  registerUser: new Endpoint(`${citizenParentUrl}/registrar`),
  userAlerts: new Endpoint(`${citizenParentUrl}/avisosImportantes`),
  startAttendance: new Endpoint(`${attendanceParentUrl}/registrar`),
  endAttendance: new Endpoint(`${attendanceParentUrl}/encerrar`),
  getAttendanceHistory: new Endpoint(`${attendanceParentUrl}/listar`),
  contactUsDemandTypes: new Endpoint(`${contactUsParentUrl}/listarTipoDemandas`),
  contactUsCities: new Endpoint(`${contactUsParentUrl}/listarMunicipios`),
  sendContactUsDemand: new Endpoint(`${contactUsParentUrl}/cadastrarDemanda`),
  satisfactionSurveyQuestions: new Endpoint(`${satisfactionSurveyParentUrl}/consultar`),
  sendSatisfactionSurveyAnswers: new Endpoint(`${satisfactionSurveyParentUrl}/salvar`),
  allServices: new Endpoint('/cartaServico/listar'),
  channelServices: new Endpoint(`${solicitationParentUrl}/listarSolicitacoes`),
  mostFrequentServices: new Endpoint(`${solicitationParentUrl}/listarSolicitacoesDestaque`),
  serviceById: new Endpoint(`${solicitationParentUrl}/listarCampos`),
  serviceDetails: new Endpoint(`${solicitationParentUrl}/cartaServico`),
  relatedServices: new Endpoint(`${solicitationParentUrl}/associadas`),
  categoryServices: new Endpoint(`${solicitationParentUrl}/grupos`),
  executeService: new Endpoint(`${solicitationParentUrl}/executarSolicitacao`),
  executeServiceStatic: new Endpoint(`${solicitationParentUrl}/executarSolicitacaoEstatica`),
  allFaqList: new Endpoint(`${faqParentUrl}/listar`),
  mostFrequentFaqList: new Endpoint(`${faqParentUrl}/listarDestaque`),
  registerFaqAccess: new Endpoint(`${faqParentUrl}/incrementa`),
  rateFaq: new Endpoint(`${faqParentUrl}/registrarAvaliacao`),
  faqCategoryList: new Endpoint(`${faqParentUrl}/listaCategoria`),
  addressTypes: new Endpoint(`${addressParentUrl}/tiposLogradouro`),
  addressFromZipCode: new Endpoint(`${addressParentUrl}/consultarEndereco`),
  statesList: new Endpoint(`${addressParentUrl}/ufs`),
  possibleLocations: new Endpoint(`${addressParentUrl}/municipios`),
  possibleAdresses: new Endpoint(`${addressParentUrl}/consultarCep`),
  fieldPossibleValues: new Endpoint(`${solicitationParentUrl}/campos/valores`),

  treatments: new Endpoint('/treatments', true), // TODO: (Futuramente) Remover mock
  topTreatments: new Endpoint('/topTreatments', true), // TODO: (Futuramente) Remover mock
  examinations: new Endpoint('/examinations', true), // TODO: (Futuramente) Remover mock
  topExaminations: new Endpoint('/topExaminations', true), // TODO: (Futuramente) Remover mock
  bills: new Endpoint('/bills', true), // TODO: (Futuramente) Remover mock
  topBills: new Endpoint('/topBills', true), // TODO: (Futuramente) Remover mock,

  formularioPesquisaPrestadores: new Endpoint(`${pesquisaPrestadores}/formulario`),
  formularioPesquisaResponder: new Endpoint(`${pesquisaPrestadores}/responder`),
  formularioPesquisaTiposResposta: new Endpoint(`${pesquisaPrestadores}/tipos-resposta`),

  simuladorSimular: new Endpoint(`${simulador}/simular`),
  simuladorFaixasEtarias: new Endpoint(`${simulador}/faixas`),

  reembolsoEtapa: new Endpoint(`${srmParentUrl}/reembolso/solicitar`),

  guiaMedicoMunicipios: new Endpoint(`${guiaMedicoParentUrl}/municipios/RS`),
  guiaMedicoServicosMedicos: new Endpoint(`${guiaMedicoParentUrl}/servicos-medicos`),
  guiaMedicoMedicos: new Endpoint(`${guiaMedicoParentUrl}/medicos`),
  guiaMedicoCirurgioesMaxiloBucal: new Endpoint(`${guiaMedicoParentUrl}/cirurgioes-maxilo-bucal`),
  guiaMedicoHospitais: new Endpoint(`${guiaMedicoParentUrl}/hospitais`),
  guiaMedicoLaboratorios: new Endpoint(`${guiaMedicoParentUrl}/laboratorios`),
  guiaMedicoClinicas: new Endpoint(`${guiaMedicoParentUrl}/clinicas`),
  guiaMedicoExamesDiagnosticos: new Endpoint(`${guiaMedicoParentUrl}/exames-diagnosticos`),
  guiaMedicoServicosEspecializados: new Endpoint(`${guiaMedicoParentUrl}/servicos-medicos/especializados`),
  guiaMedicoServicosAutorizados: new Endpoint(`${guiaMedicoParentUrl}/servicos-autorizados`),
  guiaMedicoProntoAtendimento: new Endpoint(`${guiaMedicoParentUrl}/servicos-medicos/pronto-atendimento`),
  guiaMedicoDetalhesPrestador: new Endpoint(`${guiaMedicoParentUrl}/detalhes-prestador`),

  consultaCoberturaPamesFaixas: new Endpoint(`${consultaCoberturaParentUrl}/pames/faixas`),
  consultaCoberturaCid: new Endpoint(`${consultaCoberturaParentUrl}/cid`),
  consultaCoberturaEspecialidades: new Endpoint(`${consultaCoberturaParentUrl}/especialidades`),
  consultaCoberturaEspecialidadesCategorias: new Endpoint(`${consultaCoberturaParentUrl}/especialidades/categorias`),
  consultaCoberturaExames: new Endpoint(`${consultaCoberturaParentUrl}/exames-laboratoriais-imagem`),
  consultaCoberturaProntoAtendimento: new Endpoint(`${consultaCoberturaParentUrl}/pronto-atendimento`),
  consultaCoberturaProntoAtendimentoServicos: new Endpoint(`${consultaCoberturaParentUrl}/pronto-atendimento/servicos`),
  consultaCoberturaCirurgias: new Endpoint(`${consultaCoberturaParentUrl}/cirurgias-procedimentos`),
  consultaCoberturaDespesasHospitais: new Endpoint(
    `${consultaCoberturaParentUrl}/despesas-medicas-hospitalares/hospitais`
  ),
  consultaCoberturaDespesasTipoDespesas: new Endpoint(
    `${consultaCoberturaParentUrl}/despesas-medicas-hospitalares/tipo-despesas`
  ),
  consultaCoberturaDespesasHospitaisDespesas: new Endpoint(
    `${consultaCoberturaParentUrl}/despesas-medicas-hospitalares`
  ),
  consultaCoberturaDespesasHospitaisMedicamentos: new Endpoint(
    `${consultaCoberturaParentUrl}/despesas-medicas-hospitalares/medicamentos`
  ),
  consultaCoberturaCarencias: new Endpoint(`${consultaCoberturaParentUrl}/carencias/periodos`),
  consultaCoberturaBuscaCidPorCodigo: new Endpoint(`${consultaCoberturaParentUrl}/cid/codigo`),
  consultaCoberturaBuscaCidPorNome: new Endpoint(`${consultaCoberturaParentUrl}/cid/nome`)
};
